import { useState, Fragment, useEffect } from 'react';
import { Flex, Text, theme } from '../2022-component-library';
import { keyframes } from '@emotion/react';
import { useMediaQuery } from '../helpers/useMediaQuery';

const enter = keyframes`
from {
  opacity: 0;
}
to {
  opacity: 1;
}
`;

const CoverEyePrompt = ({ eye }) => {
  const [promptDismissed, setPromptDismissed] = useState(false);
  const [message, setMessage] = useState(``);
  const oppositeEye = eye === 'left' ? 'right eye' : 'left eye';

  const tinyScreen = useMediaQuery('(max-width: 1000px)');
  const smallScreen = useMediaQuery('(max-width: 1120px)');

  useEffect(() => {
    setPromptDismissed(false);
    if (eye.includes('And')) {
      const firstEye = 'left eye';
      const secondEye = 'right eye';
      return setMessage(highlightText`Ask patient to patch/cover their ${firstEye} for the first test, then their ${secondEye} for the second.`);
    }
    return setMessage(highlightText`Ask patient to patch/cover their ${oppositeEye} as it is not being tested.`);
  }, [eye, oppositeEye]);

  return (
    <Flex
      column
      centered
      boxShadow={smallScreen ? '0' : '0px 0px 6px rgba(0, 0, 0, 0.26)'}
      borderRadius='12px'
      padding={smallScreen ? '0' : '0.75rem'}
      width={'100%'}
      opacity={promptDismissed ? '0' : '1'}
      pointerEvents={promptDismissed ? 'none' : 'auto'}
      animation={promptDismissed ? null : `${enter} 250ms forwards`}
    >
      <Text color={tinyScreen ? theme.colors.error : '#000'} fontSize={tinyScreen ? '0.875rem' : '1rem'}>
        {message}
      </Text>
    </Flex>
  );
};

export default CoverEyePrompt;

const highlightText = (strings, ...values) => (
  <span style={{ fontSize: 'h2' }}>
    {strings.map((string, index) => (
      <Fragment key={`string-${string}`}>
        {string}
        <span style={{ fontWeight: '700' }}>{values[index]}</span>
      </Fragment>
    ))}
  </span>
);
